import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";
import { aboutData } from "@/mocks/about";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-book-read-line text-xl text-primary-500"></i>
                </div>
                <span className="text-base font-heading font-semibold text-foreground-900 whitespace-nowrap">
                  布丁漫画网
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                甜蜜阅读，快乐每一天。国内领先的免费下拉式漫画阅读平台，为您提供最优质的漫画阅读体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-foreground-600"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-foreground-600"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-foreground-600"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="/category" className="hover:text-primary-600 transition-colors cursor-pointer">漫画分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    帮助中心
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    版权声明
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-foreground-500"></i>
                  </div>
                  <span>{aboutData.contact.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-foreground-500"></i>
                  </div>
                  <span>{aboutData.contact.phone}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-foreground-500"></i>
                  </div>
                  <span>{aboutData.contact.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2023-2026 布丁漫画网 PuddingComic.com 版权所有
            </p>
            <p className="text-xs text-foreground-500">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-foreground-700 transition-colors cursor-pointer">
                沪ICP备2023000000号
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}